import {
  LAUNCH_VISIT_EVENTS,
  trackLocalOpsLaunchEvent,
} from './localOpsLaunchEvents';

const API_BASE =
  process.env.REACT_APP_AZURE_API_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL_PROD ||
  '/api/v1';
const DISABLED_STORAGE_KEY = 'localops:funnelTelemetry:disabled';
const DEDUPE_STORAGE_KEY = 'localops:funnelTelemetry:dedupe:v1';
const EVENT_NAME_PATTERN = /^localops_[a-z0-9_]+$/;
const MAX_STRING_LENGTH = 160;
const DEFAULT_JOURNEY_TIMEOUT_MS = 1500;

let testTransport = null;
let testCreateSheetJourneyTransport = null;

export const LOCALOPS_FUNNEL_EVENTS = Object.freeze({
  CREATE_SHEET_OPENED: 'localops_create_sheet_opened',
  CREATE_TASK_TYPE_SELECTED: 'localops_create_task_type_selected',
  CREATE_DETAILS_STEP_REACHED: 'localops_create_details_step_reached',
  CREATE_NEXT_CLICKED: 'localops_create_next_clicked',
  CREATE_NEXT_UNAVAILABLE: 'localops_create_next_unavailable',
  CREATE_NEXT_BLOCKED: 'localops_create_next_blocked',
  CREATE_FIELD_FIRST_INTERACTION: 'localops_create_field_first_interaction',
  CREATE_LOCATION_SEARCH_STARTED: 'localops_create_location_search_started',
  CREATE_LOCATION_CANDIDATE_SELECTED:
    'localops_create_location_candidate_selected',
  CREATE_LOCATION_CONFIRMED: 'localops_create_location_confirmed',
  CREATE_LOCATION_CONFIRMATION_CLEARED:
    'localops_create_location_confirmation_cleared',
  CREATE_AMOUNT_SET: 'localops_create_amount_set',
  CREATE_REVIEW_STEP_REACHED: 'localops_create_review_step_reached',
  CREATE_STEP_BACK: 'localops_create_step_back',
  CREATE_SHEET_CLOSED: 'localops_create_sheet_closed',
  CREATE_PUBLISH_ATTEMPTED: 'localops_create_publish_attempted',
  CREATE_PUBLISH_BLOCKED: 'localops_create_publish_blocked',
  CREATE_TOPUP_REQUIRED: 'localops_create_topup_required',
  CREATE_TOPUP_STARTED: 'localops_create_topup_started',
  CREATE_PUBLISH_SUCCEEDED: 'localops_create_publish_succeeded',
  CREATE_PUBLISH_FAILED: 'localops_create_publish_failed',
  LOCATION_PRIMER_SHOWN: 'localops_location_primer_shown',
  LOCATION_BROWSE_FIRST_CLICKED: 'localops_location_browse_first_clicked',
  LOCATION_USE_MY_LOCATION_CLICKED: 'localops_location_use_my_location_clicked',
  LOCATION_PERMISSION_GRANTED: 'localops_location_permission_granted',
  LOCATION_PERMISSION_DENIED: 'localops_location_permission_denied',
  LOCATION_SAVE_ATTEMPTED: 'localops_location_save_attempted',
  LOCATION_SAVED: 'localops_location_saved',
  LOCATION_SAVE_FAILED: 'localops_location_save_failed',
  LOCATION_GATE_OPENED: 'localops_location_gate_opened',
  LOCATION_RETRY_CLICKED: 'localops_location_retry_clicked',
  LOCATION_RETRY_SUCCESS: 'localops_location_retry_success',
});

const CREATE_SHEET_JOURNEY_EVENTS = new Set([
  LOCALOPS_FUNNEL_EVENTS.CREATE_SHEET_OPENED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_TASK_TYPE_SELECTED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_DETAILS_STEP_REACHED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_NEXT_CLICKED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_NEXT_UNAVAILABLE,
  LOCALOPS_FUNNEL_EVENTS.CREATE_NEXT_BLOCKED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_FIELD_FIRST_INTERACTION,
  LOCALOPS_FUNNEL_EVENTS.CREATE_LOCATION_SEARCH_STARTED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_LOCATION_CANDIDATE_SELECTED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_LOCATION_CONFIRMED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_LOCATION_CONFIRMATION_CLEARED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_AMOUNT_SET,
  LOCALOPS_FUNNEL_EVENTS.CREATE_REVIEW_STEP_REACHED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_STEP_BACK,
  LOCALOPS_FUNNEL_EVENTS.CREATE_SHEET_CLOSED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_PUBLISH_ATTEMPTED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_PUBLISH_BLOCKED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_TOPUP_REQUIRED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_TOPUP_STARTED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_PUBLISH_SUCCEEDED,
  LOCALOPS_FUNNEL_EVENTS.CREATE_PUBLISH_FAILED,
]);

const SAFE_FIELD_TYPES = Object.freeze({
  regionSlug: 'string',
  marketSlug: 'string',
  source: 'string',
  src: 'string',
  utm_source: 'string',
  utm_campaign: 'string',
  intent: 'string',
  taskType: 'string',
  starterId: 'string',
  selectedType: 'string',
  entrySurface: 'string',
  surface: 'string',
  actionContext: 'string',
  gateReason: 'string',
  permissionState: 'string',
  errorCode: 'string',
  field: 'string',
  amountUSD: 'number',
  amountSource: 'string',
  paymentMode: 'string',
  requiresTopUp: 'boolean',
  shortfallUSD: 'number',
  hasPickup: 'boolean',
  hasDestination: 'boolean',
  hasDeliveryAddress: 'boolean',
  hasAmount: 'boolean',
  hasMedia: 'boolean',
  hasRequiredFields: 'boolean',
  hasExistingSavedLocation: 'boolean',
  wasRetry: 'boolean',
  isRideHelp: 'boolean',
  isGuidedTask: 'boolean',
  isOffering: 'boolean',
  isTask: 'boolean',
  reason: 'string',
  httpStatus: 'number',
  taskId: 'string',
  proofId: 'string',
  timestamp: 'timestamp',
});

const CREATE_SHEET_JOURNEY_FIELD_TYPES = Object.freeze({
  createFlowId: 'id',
  eventId: 'id',
  regionSlug: 'string',
  marketSlug: 'string',
  source: 'string',
  src: 'string',
  utm_source: 'string',
  utm_campaign: 'string',
  intent: 'string',
  taskType: 'string',
  starterId: 'string',
  selectedType: 'string',
  entrySurface: 'string',
  surface: 'string',
  currentStep: 'string',
  previousStep: 'string',
  actionContext: 'string',
  firstBlockingField: 'string',
  field: 'string',
  closeMethod: 'string',
  locationMethod: 'string',
  amountState: 'string',
  requiresTopUp: 'boolean',
  hasPickup: 'boolean',
  hasDestination: 'boolean',
  hasDeliveryAddress: 'boolean',
  hasAmount: 'boolean',
  hasMedia: 'boolean',
  hasRequiredFields: 'boolean',
  isRideHelp: 'boolean',
  isGuidedTask: 'boolean',
  isOffering: 'boolean',
  isTask: 'boolean',
});

const CREATE_SHEET_REASON_CODES = new Set([
  'missing_task_type',
  'missing_category',
  'missing_pickup',
  'pickup_unconfirmed',
  'pickup_outside_area',
  'missing_destination',
  'destination_unconfirmed',
  'missing_dropoff',
  'dropoff_unconfirmed',
  'invalid_amount',
  'invalid_price',
  'invalid_quantity',
  'description_too_long',
  'missing_description',
  'missing_required_fields',
  'topup_required',
  'insufficient_balance',
  'publish_blocked',
  'publish_failed',
  'location_cleared',
  'unknown',
]);

const cleanString = (value, max = MAX_STRING_LENGTH) =>
  String(value || '')
    .replace(/[\r\n\t]+/g, ' ')
    .trim()
    .slice(0, max);

const normalizeSafeTag = (value, max = MAX_STRING_LENGTH) =>
  cleanString(value, max)
    .toLowerCase()
    .replace(/[^a-z0-9:_-]+/g, '_')
    .replace(/_{2,}/g, '_')
    .replace(/^_+|_+$/g, '');

const getStorage = (storageName) => {
  if (typeof window === 'undefined') return null;
  try {
    return window[storageName] || null;
  } catch (err) {
    return null;
  }
};

const normalizeTimestamp = (value) => {
  if (value instanceof Date) {
    const time = value.getTime();
    return Number.isFinite(time) ? value.toISOString() : null;
  }
  if (typeof value === 'number') {
    const parsed = new Date(value);
    return Number.isFinite(parsed.getTime()) ? parsed.toISOString() : null;
  }
  if (typeof value === 'string') {
    const cleaned = cleanString(value, 80);
    const parsed = new Date(cleaned);
    return Number.isFinite(parsed.getTime()) ? parsed.toISOString() : null;
  }
  return null;
};

const sanitizeNumber = (value) => {
  const numeric = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(numeric) ? numeric : undefined;
};

const sanitizeValue = (value, type) => {
  if (type === 'timestamp') return normalizeTimestamp(value);
  if (type === 'id') {
    const cleaned = cleanString(value, 180);
    return /^[a-zA-Z0-9:_-]{8,180}$/.test(cleaned) ? cleaned : undefined;
  }
  if (type === 'boolean') {
    return typeof value === 'boolean' ? value : undefined;
  }
  if (type === 'number') return sanitizeNumber(value);
  if (
    value == null ||
    typeof value === 'object' ||
    typeof value === 'function' ||
    typeof value === 'symbol'
  ) {
    return undefined;
  }
  const cleaned = cleanString(value);
  return cleaned || undefined;
};

const sanitizeReasonCodes = (value) => {
  if (!Array.isArray(value)) return undefined;
  const seen = new Set();
  const safe = [];
  value.forEach((item) => {
    const normalized = normalizeSafeTag(item, 80);
    if (!normalized || !CREATE_SHEET_REASON_CODES.has(normalized)) return;
    if (seen.has(normalized)) return;
    seen.add(normalized);
    safe.push(normalized);
  });
  return safe.slice(0, 6);
};

export const sanitizeLocalOpsFunnelPayload = (payload = {}) => {
  const safe = {};
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    safe.timestamp = new Date().toISOString();
    return safe;
  }

  Object.entries(SAFE_FIELD_TYPES).forEach(([key, type]) => {
    if (!Object.prototype.hasOwnProperty.call(payload, key)) return;
    const sanitized = sanitizeValue(payload[key], type);
    if (sanitized !== undefined && sanitized !== null && sanitized !== '') {
      safe[key] = sanitized;
    }
  });

  if (!safe.timestamp) {
    safe.timestamp = new Date().toISOString();
  }

  return safe;
};

export const sanitizeLocalOpsCreateSheetJourneyPayload = (payload = {}) => {
  const safe = {};
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return safe;
  }

  Object.entries(CREATE_SHEET_JOURNEY_FIELD_TYPES).forEach(([key, type]) => {
    if (!Object.prototype.hasOwnProperty.call(payload, key)) return;
    const sanitized = sanitizeValue(payload[key], type);
    if (sanitized !== undefined && sanitized !== null && sanitized !== '') {
      safe[key] = type === 'string' ? normalizeSafeTag(sanitized) : sanitized;
    }
  });

  const reasonCodes = sanitizeReasonCodes(payload.reasonCodes);
  if (reasonCodes?.length) safe.reasonCodes = reasonCodes;

  return safe;
};

export const isLocalOpsFunnelTelemetryEnabled = () => {
  const envFlag = String(
    process.env.REACT_APP_LOCALOPS_FUNNEL_TELEMETRY_ENABLED || '',
  )
    .trim()
    .toLowerCase();
  if (envFlag === 'false') return false;

  const storage = getStorage('localStorage');
  if (!storage) return true;
  try {
    return storage.getItem(DISABLED_STORAGE_KEY) !== '1';
  } catch (err) {
    return true;
  }
};

const readDedupeState = () => {
  const storage = getStorage('sessionStorage');
  if (!storage) return null;
  try {
    const parsed = JSON.parse(storage.getItem(DEDUPE_STORAGE_KEY) || '{}');
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch (err) {
    return {};
  }
};

const writeDedupeState = (state) => {
  const storage = getStorage('sessionStorage');
  if (!storage) return false;
  try {
    storage.setItem(DEDUPE_STORAGE_KEY, JSON.stringify(state));
    return true;
  } catch (err) {
    return false;
  }
};

const shouldSkipForDedupe = ({ dedupeKey, oncePerSession, ttlMs } = {}) => {
  const key = cleanString(dedupeKey, 220);
  if (!key || (!oncePerSession && !ttlMs)) return false;

  const state = readDedupeState();
  if (!state) return false;
  const now = Date.now();
  const lastSeen = Number(state[key]);
  const hasSeen = Number.isFinite(lastSeen) && lastSeen > 0;
  const ttl = Number(ttlMs);

  if (hasSeen && oncePerSession) return true;
  if (hasSeen && Number.isFinite(ttl) && ttl > 0 && now - lastSeen < ttl) {
    return true;
  }

  state[key] = now;
  writeDedupeState(state);
  return false;
};

const buildResult = ({ ok = false, status, eventName, payload }) => ({
  ok,
  status,
  eventName,
  payload,
});

const createClientEventId = () => {
  const random =
    typeof window !== 'undefined' && window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
  return `journey:${String(random).replace(/[^a-zA-Z0-9:_-]+/g, '_')}`;
};

const buildLaunchTransport = (eventName, payload, options) => {
  const slug = cleanString(options.regionSlug || payload.regionSlug, 80);
  if (!slug) return null;
  const isFunnelEvent =
    eventName.startsWith('localops_create_') ||
    eventName.startsWith('localops_location_');
  const launchEventName = isFunnelEvent
    ? LAUNCH_VISIT_EVENTS.CTA_CLICKED
    : eventName;
  return async () => {
    const sent = await trackLocalOpsLaunchEvent({
      slug,
      eventName: launchEventName,
      sourceTag: payload.src || payload.source || payload.utm_source,
      routeKind: payload.entrySurface || payload.surface,
      intent: payload.intent,
      ctaId: isFunnelEvent ? eventName : undefined,
      landingIntentType:
        payload.actionContext || payload.amountSource || undefined,
      targetKind:
        payload.reason ||
        payload.gateReason ||
        payload.errorCode ||
        payload.field ||
        payload.paymentMode ||
        undefined,
      starterId: payload.starterId,
    });
    if (!sent) {
      throw new Error('LocalOps launch telemetry was not sent');
    }
  };
};

const resolveTransport = (eventName, payload, options = {}) => {
  if (typeof options.transport === 'function') return options.transport;
  if (options.transport === 'launch') {
    return buildLaunchTransport(eventName, payload, options);
  }
  return testTransport;
};

const buildCreateSheetJourneyEndpoint = (slug) => {
  const base = String(API_BASE || '/api/v1').replace(/\/+$/, '');
  return `${base}/offline-regions/${encodeURIComponent(
    slug,
  )}/create-sheet-journey-events`;
};

const postCreateSheetJourneyPayload = async (eventName, payload, options = {}) => {
  const slug = cleanString(options.regionSlug || payload.regionSlug, 80);
  if (!slug || typeof fetch !== 'function') {
    throw new Error('Create Sheet diagnostics transport unavailable');
  }
  const endpoint = buildCreateSheetJourneyEndpoint(slug);
  const timeoutMs = Math.max(
    250,
    Math.min(Number(options.timeoutMs) || DEFAULT_JOURNEY_TIMEOUT_MS, 3000),
  );
  const controller =
    typeof AbortController === 'function' ? new AbortController() : null;
  const timer = controller
    ? setTimeout(() => controller.abort(), timeoutMs)
    : null;
  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ eventName, ...payload }),
      credentials: 'omit',
      signal: controller?.signal,
    });
    if (!response.ok) {
      throw new Error('Create Sheet diagnostics were not accepted');
    }
  } finally {
    if (timer) clearTimeout(timer);
  }
};

export const recordLocalOpsFunnelEvent = async (
  eventName,
  payload = {},
  options = {},
) => {
  const safeEventName = cleanString(eventName, 96);
  const safePayload = sanitizeLocalOpsFunnelPayload(payload);

  if (!EVENT_NAME_PATTERN.test(safeEventName)) {
    return buildResult({
      status: 'invalid_event',
      eventName: safeEventName || undefined,
      payload: safePayload,
    });
  }

  if (!isLocalOpsFunnelTelemetryEnabled()) {
    return buildResult({
      status: 'disabled',
      eventName: safeEventName,
      payload: safePayload,
    });
  }

  if (shouldSkipForDedupe(options)) {
    return buildResult({
      status: 'deduped',
      eventName: safeEventName,
      payload: safePayload,
    });
  }

  const transport = resolveTransport(safeEventName, safePayload, options);
  if (!transport) {
    return buildResult({
      status: 'skipped',
      eventName: safeEventName,
      payload: safePayload,
    });
  }

  try {
    await Promise.resolve(
      transport({
        eventName: safeEventName,
        payload: safePayload,
        options,
      }),
    );
    return buildResult({
      ok: true,
      status: 'sent',
      eventName: safeEventName,
      payload: safePayload,
    });
  } catch (err) {
    return buildResult({
      status: 'failed',
      eventName: safeEventName,
      payload: safePayload,
    });
  }
};

export const recordLocalOpsCreateSheetJourneyEvent = async (
  eventName,
  payload = {},
  options = {},
) => {
  const safeEventName = cleanString(eventName, 96);
  const eventId = payload?.eventId || createClientEventId();
  const safePayload = sanitizeLocalOpsCreateSheetJourneyPayload({
    ...payload,
    eventId,
  });

  if (!CREATE_SHEET_JOURNEY_EVENTS.has(safeEventName)) {
    return buildResult({
      status: 'invalid_event',
      eventName: safeEventName || undefined,
      payload: safePayload,
    });
  }
  if (!safePayload.createFlowId || !safePayload.eventId) {
    return buildResult({
      status: 'invalid_payload',
      eventName: safeEventName,
      payload: safePayload,
    });
  }
  if (!isLocalOpsFunnelTelemetryEnabled()) {
    return buildResult({
      status: 'disabled',
      eventName: safeEventName,
      payload: safePayload,
    });
  }

  try {
    const transport = testCreateSheetJourneyTransport;
    if (transport) {
      await Promise.resolve(
        transport({
          eventName: safeEventName,
          payload: safePayload,
          options,
        }),
      );
    } else {
      await postCreateSheetJourneyPayload(safeEventName, safePayload, options);
    }
    return buildResult({
      ok: true,
      status: 'sent',
      eventName: safeEventName,
      payload: safePayload,
    });
  } catch (err) {
    return buildResult({
      status: 'failed',
      eventName: safeEventName,
      payload: safePayload,
    });
  }
};

export const __setLocalOpsFunnelTelemetryTransportForTests = (transport) => {
  testTransport = typeof transport === 'function' ? transport : null;
  return () => {
    testTransport = null;
  };
};

export const __setLocalOpsCreateSheetJourneyTransportForTests = (transport) => {
  testCreateSheetJourneyTransport =
    typeof transport === 'function' ? transport : null;
  return () => {
    testCreateSheetJourneyTransport = null;
  };
};
